import { Component, input, output, model } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LucideIconComponent } from '../../lucide-icon/lucide-icon.component';
import { HeadingComponent } from '../../typography/heading/heading.component';
import { TextComponent } from '../../typography/text/text.component';
import { ButtonComponent } from '../../button/button.component';
import { ColorVariant } from '../../../../core/enums/types';

@Component({
  selector: 'app-card',
  standalone: true,
  imports: [
    CommonModule,
    LucideIconComponent,
    HeadingComponent,
    TextComponent,
    ButtonComponent,
  ],
  templateUrl: './card.component.html',
  styleUrl: './card.component.css',
})
export class CardComponent {
  accentStyle = input<ColorVariant>(null); // Default accent style
  secondaryAccentStyle = input<ColorVariant>(null); // Optional secondary accent ribbon
  secondaryAccentTooltip = input<string>();
  accentPosition = input<'left' | 'top'>('top'); // Default position is top
  accentWidth = input<'1' | '2'>('2'); // Default width is 2
  headerText = input<string>();
  size = input<'sm' | 'md' | 'lg'>('md'); // Default size is medium
  icon = input<string>();
  editable = input(false);
  editBtnTooltip = input<string>();
  edit = output<void>();
  overridePadding = input(false);
  selected = input(false);
  collapsible = input(false);
  collapsed = model(false);
  hideOverflow = input(true);
  footerVariant = input<'default' | 'forwarded'>('default');

  toggleCollapse(): void {
    if (this.collapsible()) {
      this.collapsed.update((val) => !val);
    }
  }
}
